import { render, staticRenderFns } from "./UserProfileSetting.vue?vue&type=template&id=279e3c3b&"
import script from "./UserProfileSetting.vue?vue&type=script&lang=js&"
export * from "./UserProfileSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279e3c3b')) {
      api.createRecord('279e3c3b', component.options)
    } else {
      api.reload('279e3c3b', component.options)
    }
    module.hot.accept("./UserProfileSetting.vue?vue&type=template&id=279e3c3b&", function () {
      api.rerender('279e3c3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/UserProfileSetting.vue"
export default component.exports